import { useCustomToast } from '@/hooks/use-custom-toast';
import { useCallback } from 'react';

interface IUserShareTicket {
  spaceId: string;
  ticketId: string;
  isArchived?: boolean;
}

const TOAST_MESSAGE = {
  ERROR_COPY_TICKET_LINK: 'Error copy ticket link, please try again!',
  SUCCESS_COPY_TICKET_LINK: 'Ticket link copied to clipboard!',
};

const useShareTicket = ({ spaceId, ticketId, isArchived }: IUserShareTicket) => {
  // HOOKS
  const showToast = useCustomToast();

  // HANDLERS
  const handleShareTicket = useCallback(() => {
    if (!spaceId || !ticketId) {
      return;
    }
    try {
      let URL = '';
      if (isArchived) {
        URL = `${window.location.origin}/ticketing?space=${spaceId}&ticket=${ticketId}&spaceTab=archive`;
      } else {
        URL = `${window.location.origin}/ticketing?space=${spaceId}&ticket=${ticketId}`;
      }
      navigator.clipboard.writeText(URL);
      showToast({ message: TOAST_MESSAGE.SUCCESS_COPY_TICKET_LINK, type: 'success' });
    } catch (_error) {
      showToast({ message: TOAST_MESSAGE.ERROR_COPY_TICKET_LINK, type: 'error' });
    }
  }, [spaceId, ticketId, isArchived, showToast]);

  return {
    handleShareTicket,
  };
};

export default useShareTicket;
